var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cart-index',{attrs:{"cart":_vm.getCart,"changes":_vm.changes}})}
var staticRenderFns = []

export { render, staticRenderFns }